<div class="noData">
  <div class="noData__icon">
    <mat-icon fontIcon="warning"></mat-icon>
  </div>
  <div class="noData__text">
    <span>No existe informacion para mostrar en la tabla</span>
  </div>
</div>
